var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "community") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Community"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 96.21,
    y: 60.17,
    width: 9.16,
    height: 39.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.28,
    y: 60.17,
    width: 9.16,
    height: 39.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.56,
    y: 54.28,
    width: 88.88,
    height: 5.59
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "109.44 54.28 20.56 54.28 20.56 43.7 65 19.66 109.44 43.7 109.44 54.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.56,
    y: 100.26,
    width: 88.88,
    height: 10.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.65,
    y: 60.17,
    width: 50.7,
    height: 39.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.29,82.53V99.89H72.71V82.53A7.38,7.38,0,0,0,65,75.72C58.43,75.72,57.29,81.17,57.29,82.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.4f648690d41f0845837fdbc3f877f6a6.svg";
export { ForwardRef as ReactComponent };